import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SelectProps, RefSelectProps } from 'antd'
import * as managers from 'modules/domain/company/managers'
import { PartnerType } from 'modules/domain/company/types'
import GenericMultiSelect from '../Generics/GenericMultiSelect'

type AntDPartnerTypeSelectProps = {
  onChange: SelectProps['onChange']
  placeholder?: string
  title?: string
}

const AntDPartnerTypeSelect: React.FC<AntDPartnerTypeSelectProps> = ({
  onChange,
  placeholder,
  title = 'Partner Type',
}) => {
  const { t } = useTranslation('labels')
  const [partnerTypes, setPartnerTypes] = useState<PartnerType[]>([])
  const [loading, setLoading] = useState(false)
  const selectRef = useRef<RefSelectProps>(null)

  useEffect(() => {
    const fetchPartnerTypes = async () => {
      setLoading(true)
      try {
        const response = await managers.fetchPartnerTypes()
        setPartnerTypes(response.data)
      } catch (error) {
        console.error('Failed to fetch partner types:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchPartnerTypes()
  }, [])

  const partnerTypeSelectItems = partnerTypes.map((partnerType) => ({
    value: partnerType.id,
    label: partnerType.details,
  }))

  const handleOnChange: SelectProps['onChange'] = (value, option) => {
    if (selectRef.current) {
      selectRef.current.blur()
    }
    if (onChange) {
      onChange(value, option)
    }
  }

  return (
    <GenericMultiSelect
      ref={selectRef}
      placeholder={placeholder || t('partnerType')}
      title={title}
      options={partnerTypeSelectItems}
      loading={loading}
      onChange={handleOnChange}
    />
  )
}

export default AntDPartnerTypeSelect
